import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, withCtx as _withCtx, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/iconite/cos.png'


const _withScopeId = n => (_pushScopeId("data-v-6af5f665"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "q-pa-sm ecran-container" }
const _hoisted_2 = { style: {"display":"flex"} }
const _hoisted_3 = {
  key: 0,
  class: "app__color--label q-ma-md"
}
const _hoisted_4 = { style: {"white-space":"nowrap","font-size":"2rem"} }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  style: {"position":"relative","width":"24px","height":"24px","margin-right":"4px"}
}, null, -1))
const _hoisted_6 = {
  key: 0,
  class: "app__label--medium app__color--semigray",
  style: {"padding-top":"5rem"}
}
const _hoisted_7 = {
  key: 1,
  class: "q-pa-md"
}
const _hoisted_8 = { style: {"color":"black","font-weight":"bold"} }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_11 = {
  class: "produs_img",
  style: {"display":"flex","flex-direction":"row"}
}
const _hoisted_12 = { style: {"display":"flex","align-items":"center","flex-direction":"column","gap":"2px"} }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "absolute-full flex flex-center bg-negative text-white" }, " Cannot load image ", -1))
const _hoisted_14 = { class: "produs_detalii" }
const _hoisted_15 = { class: "app__property--medium" }
const _hoisted_16 = {
  class: "app__color--semigray",
  style: {"font-weight":"lighter"}
}
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = { key: 2 }
const _hoisted_20 = { key: 3 }
const _hoisted_21 = { key: 4 }
const _hoisted_22 = { key: 5 }
const _hoisted_23 = { key: 6 }
const _hoisted_24 = { key: 7 }
const _hoisted_25 = {
  key: 0,
  class: "app__color--semigray",
  style: {"font-weight":"lighter","font-style":"italic"}
}
const _hoisted_26 = { class: "app__property--medium" }
const _hoisted_27 = { key: 0 }
const _hoisted_28 = { key: 1 }
const _hoisted_29 = { class: "shopping_cart__container--btns" }
const _hoisted_30 = { key: 0 }
const _hoisted_31 = { key: 1 }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_33 = { style: {"display":"flex","flex-direction":"row","width":"100%"} }
const _hoisted_34 = { style: {"color":"black","font-weight":"bold"} }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_36 = {
  class: "app__property--medium",
  style: {"display":"flex","flex-direction":"column","margin-left":"auto"}
}
const _hoisted_37 = { style: {"color":"black","font-weight":"bold"} }
const _hoisted_38 = { style: {"color":"black","font-weight":"bold"} }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_40 = { style: {"display":"flex","flex-direction":"row","width":"100%"} }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_42 = { style: {"display":"flex","flex-direction":"column"} }
const _hoisted_43 = { style: {"color":"black","font-weight":"bold","margin-bottom":"8px"} }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_45 = /*#__PURE__*/_createTextVNode("Close")
const _hoisted_46 = {
  key: 3,
  class: "app__title--small",
  style: {"position":"absolute","left":"50%","margin-left":"-100px"}
}
const _hoisted_47 = {
  key: 4,
  class: "app__back__bar--title",
  style: {"position":"absolute","left":"calc(50% - 100px)","top":"10px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_linear_progress = _resolveComponent("q-linear-progress")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_img = _resolveComponent("q-img")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_EditQuantityArticleCerere = _resolveComponent("EditQuantityArticleCerere")!
  const _component_q_banner = _resolveComponent("q-banner")!
  const _component_q_popup_proxy = _resolveComponent("q-popup-proxy")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_select = _resolveComponent("q-select")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_space = _resolveComponent("q-space")!
  const _component_q_bar = _resolveComponent("q-bar")!
  const _component_NomEditAdresaLivrare = _resolveComponent("NomEditAdresaLivrare")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.$q.platform.is.desktop)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("span", _hoisted_4, [
                _hoisted_5,
                _createTextVNode(_toDisplayString(_ctx.$t('message.my_basket')), 1)
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      (_ctx.basket.length ==0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.$t('message.no_items_in_basket')), 1))
        : (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("span", _hoisted_8, [
              _createTextVNode(_toDisplayString(_ctx.$t('message.items_in_basket')) + ": " + _toDisplayString(_ctx.basket.length), 1),
              _hoisted_9
            ]),
            _hoisted_10,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.basket, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: item.appid,
                class: "produs_div"
              }, [
                (item.appid==_ctx.appidToBeRemovedFromBasket)
                  ? (_openBlock(), _createBlock(_component_q_linear_progress, {
                      key: 0,
                      indeterminate: "",
                      color: "secondary",
                      style: {"position":"absolute"}
                    }))
                  : _createCommentVNode("", true),
                (item.appid==_ctx.appidToBeTogglesWithFavorites)
                  ? (_openBlock(), _createBlock(_component_q_linear_progress, {
                      key: 1,
                      indeterminate: "",
                      color: "secondary",
                      style: {"position":"absolute"}
                    }))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _createVNode(_component_q_btn, {
                      flat: "",
                      icon: "arrow_drop_up",
                      onClick: ($event: any) => (_ctx.moveUP(index))
                    }, null, 8, ["onClick"]),
                    _createVNode(_component_q_item_label, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(index+1), 1)
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_q_btn, {
                      flat: "",
                      icon: "arrow_drop_down",
                      onClick: ($event: any) => (_ctx.moveDown(index))
                    }, null, 8, ["onClick"])
                  ]),
                  _createVNode(_component_q_img, {
                    transition: "fade",
                    src: _ctx.urlToJPG+'/'+item.categoryPid,
                    ratio: "1",
                    fit: "scale-down",
                    "spinner-color": "light-blue",
                    class: "rounded-borders shopping_cart--img shadow-1"
                  }, {
                    error: _withCtx(() => [
                      _hoisted_13
                    ]),
                    _: 2
                  }, 1032, ["src"])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.$i18n.locale == 'de' ? item.productNameDe : _ctx.$i18n.locale == 'ro' ? item.productNameRo : _ctx.$i18n.locale == 'en' ? item.productNameEn : item.productNameHu), 1),
                  _createElementVNode("span", _hoisted_16, [
                    (item.l)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(_ctx.$t('message.length')) + " " + _toDisplayString(item.l) + " " + _toDisplayString(item.um1 == 'M' ? 'M ' : 'mm '), 1))
                      : _createCommentVNode("", true),
                    (item.w)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(_ctx.$t('message.width')) + " " + _toDisplayString(item.w) + " mm ", 1))
                      : _createCommentVNode("", true),
                    (item.t)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(_ctx.$t('message.thickness')) + " " + _toDisplayString(item.t) + " mm ", 1))
                      : _createCommentVNode("", true),
                    (item.d)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(_ctx.$t('message.diameter')) + " " + _toDisplayString(item.d) + " mm ", 1))
                      : _createCommentVNode("", true),
                    (item.h)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(_ctx.$t('message.height')) + " " + _toDisplayString(item.h) + " mm ", 1))
                      : _createCommentVNode("", true),
                    (item.a)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(_ctx.$t('message.aliaj')) + " " + _toDisplayString(item.a) + "  ", 1))
                      : _createCommentVNode("", true),
                    (item.k)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(_ctx.$t('message.eyes')) + " " + _toDisplayString(item.k) + " mm ", 1))
                      : _createCommentVNode("", true),
                    (item.e)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(_ctx.$t('message.eyes')) + " 2 " + _toDisplayString(item.e) + " mm ", 1))
                      : _createCommentVNode("", true)
                  ]),
                  (item.observatii)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(_ctx.$t('message.remarks')) + ": " + _toDisplayString(item.observatii), 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_26, [
                  (item.tip_um == 'um12' || item.tip_um == 'um1')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_27, _toDisplayString(item.qUm1) + " " + _toDisplayString(item.um1), 1))
                    : _createCommentVNode("", true),
                  (item.um2 && item.um2.length>0 && item.qUm2>0 && (item.tip_um == 'um12' || item.tip_um == 'um2'))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_28, _toDisplayString(item.qUm2) + " KG", 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_29, [
                  _createVNode(_component_q_btn, {
                    color: "red",
                    flat: "",
                    onClick: ($event: any) => (_ctx.removeArticleFromShoppingCart(item)),
                    "no-caps": "",
                    "no-wrap": "",
                    dense: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_icon, {
                        left: "",
                        name: "delete_forever"
                      }),
                      _createVNode(_component_q_tooltip, {
                        anchor: "top middle",
                        self: "bottom middle",
                        offset: [10, 10],
                        "transition-show": "scale",
                        "transition-hide": "scale"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('message.delete_basket')), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 2
                  }, 1032, ["onClick"]),
                  _createVNode(_component_q_btn, {
                    icon: "edit",
                    flat: "",
                    style: {"color":"#9b7d32"},
                    "no-caps": "",
                    "no-wrap": "",
                    dense: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_popup_proxy, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_banner, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_EditQuantityArticleCerere, {
                                item: item,
                                index: index,
                                onEditItem: _ctx.onEditItem
                              }, null, 8, ["item", "index", "onEditItem"])
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_q_tooltip, {
                        anchor: "top middle",
                        self: "bottom middle",
                        offset: [10, 10],
                        "transition-show": "scale",
                        "transition-hide": "scale"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('message.modify_quantity')), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_q_btn, {
                    flat: "",
                    "no-caps": "",
                    "no-wrap": "",
                    dense: "",
                    onClick: ($event: any) => (_ctx.toggleArticleInFavorites(item))
                  }, {
                    default: _withCtx(() => [
                      (item.isInFavorite)
                        ? (_openBlock(), _createBlock(_component_q_icon, {
                            key: 0,
                            left: "",
                            name: "favorite",
                            style: {"color":"#9b7d32"}
                          }))
                        : (_openBlock(), _createBlock(_component_q_icon, {
                            key: 1,
                            left: "",
                            name: "favorite_border",
                            style: {"color":"#9b7d32"}
                          })),
                      _createVNode(_component_q_tooltip, {
                        anchor: "top middle",
                        self: "bottom middle",
                        offset: [10, 10],
                        "transition-show": "scale",
                        "transition-hide": "scale"
                      }, {
                        default: _withCtx(() => [
                          (item.isInFavorite)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_30, _toDisplayString(_ctx.$t('message.item_in_favorite_remove')), 1))
                            : (_openBlock(), _createElementBlock("span", _hoisted_31, _toDisplayString(_ctx.$t('message.add_to_favorite')), 1))
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ])
              ]))
            }), 128)),
            _hoisted_32,
            _createElementVNode("div", _hoisted_33, [
              _createElementVNode("span", _hoisted_34, [
                _createTextVNode(_toDisplayString(_ctx.$t('message.delivery_details')), 1),
                _hoisted_35
              ]),
              _createElementVNode("div", _hoisted_36, [
                _createElementVNode("span", _hoisted_37, _toDisplayString(_ctx.$t('message.total_quantity')) + ":", 1),
                _createElementVNode("span", _hoisted_38, _toDisplayString(_ctx.getTotalQuantity()) + " KG", 1)
              ])
            ]),
            _hoisted_39,
            _createElementVNode("div", {
              class: _normalizeClass(_ctx.$q.platform.is.mobile ? 'div_card_mobile' : 'div_card_desktop')
            }, [
              _createElementVNode("div", _hoisted_40, [
                _createVNode(_component_q_select, {
                  outlined: "",
                  label: _ctx.$t('message.delivery_address'),
                  modelValue: _ctx.slidAdresaLivrare,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.slidAdresaLivrare) = $event)),
                  "option-value": "slid",
                  "option-label": "adresaAdresa",
                  options: _ctx.adrese,
                  "emit-value": "",
                  "map-options": "",
                  "options-selected-class": "text-deep-orange",
                  style: _normalizeStyle(_ctx.$q.platform.is.mobile ? 'width: 100%;' : 'width:clamp(200px, 40vw, 400px);')
                }, {
                  option: _withCtx((scope) => [
                    _createVNode(_component_q_item, _normalizeProps(_guardReactiveProps(scope.itemProps)), {
                      default: _withCtx(() => [
                        _createVNode(_component_q_item_section, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_q_item_label, {
                              caption: scope.opt.isNewAddress == '1'
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(scope.opt.adresaLocalitate), 1)
                              ]),
                              _: 2
                            }, 1032, ["caption"]),
                            _createVNode(_component_q_item_label, { caption: "" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(scope.opt.adresaAdresa), 1)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1040)
                  ]),
                  _: 1
                }, 8, ["label", "modelValue", "options", "style"]),
                (!_ctx.dialogAdresa)
                  ? (_openBlock(), _createBlock(_component_q_btn, {
                      key: 0,
                      square: "",
                      icon: "add",
                      style: {"height":"1rem","width":"1rem","margin-left":"4px","margin-top":"8px","background-color":"#9b7d32","color":"white"},
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onOpenFormAddNewAdresa()))
                    }))
                  : _createCommentVNode("", true)
              ])
            ], 2),
            _hoisted_41,
            _createElementVNode("div", _hoisted_42, [
              _createElementVNode("div", _hoisted_43, _toDisplayString(_ctx.$t('message.remarks')) + ":", 1),
              _createVNode(_component_q_input, {
                maxlength: "1000",
                type: "textarea",
                autogrow: "",
                counter: "",
                class: "input--desire",
                outlined: "",
                modelValue: _ctx.inputFreeTextComments,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.inputFreeTextComments) = $event)),
                placeholder: _ctx.$t('message.new_request_details'),
                dense: "",
                color: "blue-grey-7"
              }, null, 8, ["modelValue", "placeholder"])
            ]),
            _hoisted_44,
            ( _ctx.basket.length>0)
              ? (_openBlock(), _createBlock(_component_q_btn, {
                  key: 0,
                  style: _normalizeStyle([{"background-color":"#9b7d32","color":"white"}, _ctx.$q.platform.is.mobile ? 'width: 100%;' : 'width: 250px;float:right;']),
                  label: _ctx.$t('message.send_offer_request'),
                  "no-caps": "",
                  onClick: _ctx.trySendBasketForAnOffer
                }, null, 8, ["label", "onClick", "style"]))
              : _createCommentVNode("", true)
          ]))
    ]),
    _createVNode(_component_q_dialog, {
      modelValue: _ctx.dialogAdresa,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.dialogAdresa) = $event)),
      persistent: "",
      maximized: true,
      "transition-show": _ctx.dialogTransitionShow,
      "transition-hide": _ctx.dialogTransitionHide
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, { class: "bg-white" }, {
          default: _withCtx(() => [
            _createVNode(_component_q_bar, { class: "bg-white" }, {
              default: _withCtx(() => [
                (_ctx.$q.platform.is.desktop)
                  ? _withDirectives((_openBlock(), _createBlock(_component_q_btn, {
                      key: 0,
                      dense: "",
                      flat: "",
                      icon: "arrow_back",
                      color: "black"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_tooltip, { "content-class": "bg-grey text-white" }, {
                          default: _withCtx(() => [
                            _hoisted_45
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 512)), [
                      [_directive_close_popup]
                    ])
                  : _createCommentVNode("", true),
                (_ctx.$q.platform.is.desktop)
                  ? (_openBlock(), _createBlock(_component_q_space, {
                      key: 1,
                      dense: ""
                    }))
                  : _createCommentVNode("", true),
                (_ctx.$q.platform.is.mobile)
                  ? _withDirectives((_openBlock(), _createBlock(_component_q_icon, {
                      key: 2,
                      name: "arrow_back_ios",
                      class: "app__arrow--back"
                    }, null, 512)), [
                      [_directive_close_popup]
                    ])
                  : _createCommentVNode("", true),
                (_ctx.$q.platform.is.desktop)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_46, _toDisplayString(_ctx.$t('message.delivery_address_details')), 1))
                  : _createCommentVNode("", true),
                (_ctx.$q.platform.is.mobile)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_47, _toDisplayString(_ctx.$t('message.delivery_address_details')), 1))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_q_card_section, null, {
              default: _withCtx(() => [
                _createVNode(_component_NomEditAdresaLivrare, {
                  propAdresa: _ctx.selectedAdresa,
                  closeHandler: _ctx.closeFormEditAdresaLivrare
                }, null, 8, ["propAdresa", "closeHandler"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue", "transition-show", "transition-hide"])
  ]))
}